/**
 * Sign up process.
 */

'use strict';

var ui = require('../actors/archive');

// Constructor
var FrontHome = function () {
    if (!$('body').hasClass('home')) {
        return;
    }

    this.postSendCompleteForm(); 

    $(document).ready((function () {
        ui.uiInitSearchForm();
        ui.uiInitAgeRange();
        ui.uiSlideDownAdvancedSearch();
        ui.thumbActorOnHover();
        ui.prepareData();
        this.eventsSlider();
    }).bind(this));
};

FrontHome.prototype = {
    /**
     * Initialize the events slider.
     */
    eventsSlider: function() {
        if (!$.fn.slick) {
            return;
        }

        $('#front-events .event-listing').slick({
            infinite: false,
            prevArrow: $('#front-events .slick-prev'),
            nextArrow: $('#front-events .slick-next'),
            slidesToShow: 3,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
        });
    },

    /**
     * Send the search form to the actors listing.
     */
    postSendCompleteForm : function() {
        $('#actors-search').submit(function(e) {
            e.preventDefault();
            $('#advanced-actors-search').submit();
        });

        $('#advanced-actors-search').submit(function(e) {
            var submittedForm = $(this);

            var searchValues = [];
            searchValues['nameActor'] = $('#actors-search #nameActor').val();

            if ($('#actors-search #age').attr('data-0') !== null || $('#age').attr('data-0') !== undefined) {
                searchValues['minAgeValue'] = Math.floor($('#age').attr('data-0'));
            } else {
                searchValues['minAgeValue'] = 0;
            }

            if ($('#actors-search #age').attr('data-1') !== null || $('#age').attr('data-1') !== undefined) {
                searchValues['maxAgeValue'] = Math.floor($('#age').attr('data-1'));
            } else {
                searchValues['maxAgeValue'] = 0;
            }

            var sexeObj = $('#actors-search #sexe').val();
            $.each(sexeObj, function(index, value) {
                searchValues['sexeValue_' + value] = true;
            });

            searchValues['fromHomepage'] = true;

            for (var i in searchValues) {
                var input = $('<input />').attr('type', 'hidden')
                    .attr("id", i)
                    .attr('name', i)
                    .val(searchValues[i]);
                submittedForm.append($(input));
            }

            return true;
        });
    }
};

module.exports = new FrontHome();
